import { useState } from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const LABELS: Record<string, string> = {
  dashboard: 'Dashboard', tickets: 'Tickets', new: 'New', approvals: 'Approvals',
  'all-tickets': 'All Tickets', tasks: 'Tasks', reports: 'Reports', admin: 'Admin',
  employees: 'Employees', 'approval-chains': 'Approval Chains',
};

function Breadcrumbs() {
  const { pathname } = useLocation();
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return null;
  return (
    <nav className="flex items-center gap-1.5 text-sm text-gray-400 px-5 pt-4" aria-label="Breadcrumb">
      <Link to="/dashboard" className="hover:text-navy">Home</Link>
      {parts.map((p, i) => {
        const to = '/' + parts.slice(0, i + 1).join('/');
        const label = LABELS[p] ?? (p.length > 20 ? p.slice(0, 20) + '…' : p);
        const last = i === parts.length - 1;
        return (
          <span key={to} className="flex items-center gap-1.5">
            <ChevronRight size={13} />
            {last ? <span className="text-navy font-medium">{label}</span>
                  : <Link to={to} className="hover:text-navy">{label}</Link>}
          </span>
        );
      })}
    </nav>
  );
}

export default function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="flex min-h-screen bg-gray-50">
      {sidebarOpen && (
        <div className="fixed inset-0 z-20 bg-black/50 md:hidden" onClick={() => setSidebarOpen(false)} />
      )}
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar onOpenSidebar={() => setSidebarOpen(true)} />
        <main className="flex-1 min-w-0 overflow-y-auto">
          <Breadcrumbs />
          <Outlet />
        </main>
      </div>
    </div>
  );
}
